import { jsx, jsxs } from "react/jsx-runtime";
//#region src/assets/svg/ErrorFault.tsx
function SvgErrorFault(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: 91,
		height: 90,
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ jsx("circle", {
				cx: 45.5,
				cy: 45,
				r: 45,
				fill: "#FBC5B3"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M45.5 41.25v7.5m10.313 13.125H26.75L45.5 26.25l18.75 35.625h-8.438Z",
				stroke: "#F45A27",
				strokeWidth: 3.75,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M45.5 56.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
				fill: "#F45A27"
			})
		]
	});
}
//#endregion
export { SvgErrorFault as default };

//# sourceMappingURL=ErrorFault.mjs.map